import { PaginationGridInterface, PaginationResponseInterface } from '@ui-kit';

export enum CampaignStatus {
  Draft = 'Draft',
  Publishing = 'Publishing',
  Published = 'Published',
  PublishingFailed = 'PublishingFailed',
  Configurable = 'Configurable',
  Configured = 'Configured',
}

export enum CampaignType {
  Marketplace = 'Marketplace',
  Private = 'Private',
}

export enum ReferralCodeType {
  Code = 'Code',
  Branch = 'Branch',
  StaticUserCode = 'StaticUserCode',
  StaticUserWordCode = 'StaticUserWordCode',
}

export interface CampaignsRequestDto extends PaginationGridInterface {
  search: string | null;
  statuses: CampaignStatus[] | null;
  campaignTypes: CampaignType[] | null;
  organizationIds?: string[] | null;
}

export interface CampaignListDto {
  id: string;
  externalId: string | null;
  name: string;
  referralCodeType: ReferralCodeType | string;
  promotionTitle: string;
  promotionDescription: string;
  websiteUrl: string;
  status: CampaignStatus | string;
  organizationId: string;
  createdOnUtc: string | null;
  isActive: boolean;
}

export interface CampaignsResponseDto extends PaginationResponseInterface {
  campaigns: CampaignListDto[];
}

export interface CampaignDetailsDto extends CampaignListDto {
  brandId: string | null;
  imageUrl: string | null;
  campaignType: CampaignType | string | null;
  statusMessage: string | null;
  createdBy: string | null;
  modifiedOnUtc: string | null;
}

export interface CreateCampaignDto {
  name: string;
  promotionTitle: string;
  promotionDescription: string;
  websiteUrl: string;
  organizationId?: string | null;
  brandId: string | null;
  campaignType?: CampaignType | null;
}

export interface CampaignResponseDto {
  id: string;
  externalId: string | null;
  name: string;
  referralCodeType: string;
  promotionTitle: string;
  promotionDescription: string;
  websiteUrl: string;
  imageUrl: string | null;
  organizationId: string;
  campaignType: string | null;
  status: string;
  brandId: string | null;
  createdBy: string | null;
  createdOnUtc: string | null;
}
